import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.regexp.to-string.js";
import "core-js/modules/es6.object.to-string.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { Box } from '../Box/Box';

var getColorForLevel = function getColorForLevel(level) {
  if (level.toString() === '1') {
    return 'neutral-dark';
  }

  if (level.toString() === '3') {
    return 'neutral-lightest';
  }

  return 'neutral-lighter';
};
/**
 * Composes the horizontal rule (<hr>) standard
 * HTML element which provides a thematic break between
 * content.
 *
 * With this implementation of Divider, we reset the
 * default border and use a border-top to style the <hr>.
 */


export var Divider = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$level = _ref.level,
      level = _ref$level === void 0 ? 2 : _ref$level,
      className = _ref.className,
      style = _ref.style,
      other = _objectWithoutProperties(_ref, ["level", "className", "style"]);

  // TODO: in Currency v2, remove default margin from `<hr>` tag.
  // This fits with our best practice of "components should not
  // come with any built-in external spacing".
  return /*#__PURE__*/React.createElement(Box, _extends({
    component: "hr",
    border: "0",
    borderTop: "1",
    borderColor: getColorForLevel(level),
    className: className,
    style: style,
    ref: ref
  }, other));
});
Divider.displayName = 'Divider';

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line @typescript-eslint/no-var-requires, global-require
  var PropTypes = require('prop-types');

  Divider.propTypes = {
    /** Applies a CSS classname to the component. */
    className: PropTypes.string,

    /**
     * Levels of lightness. 3 is the lightest which maps
     * to the design token from the design system, "neutral-lightest".
     */
    level: PropTypes.oneOf([1, 2, 3, '1', '2', '3'])
  };
}